<ng-container *rxFor="let stayView of stayViews; trackBy: trackByStayDetail">
  @if (
    {
      canRenderStays: timelineStaysSuggestionService.canRenderStays$ | async,
      left: stayView.stay.startDatetime | ganttStartingPixel | async,
      right:
        [stayView.stay.startDatetime, stayView.stay.endDatetime]
        | ganttEndingPixel
        | async,
      stayIdsToHighlight: stayIdsToHighlight$ | async,
      validatedStays:
        timelineStaysSuggestionService.validatedStaysInRangeMap$ | async,
    };
    as data
  ) {
    @if (
      {
        adjustedLeftPixel: (data?.left ?? 0) + STAYS_TIMELINE_ADJUSTMENT_PIXEL,
        isStayHighlighted: data.stayIdsToHighlight?.includes(stayView.stay.id),
      };
      as stayData
    ) {
      <div>
        @let stayTemplate = deferredStayCardHelperService.getStayTemplate();
        @let contextData =
          {
            stayId: stayView.stay.id,
            leftPx: stayData.adjustedLeftPixel,
            rightPx: data.right,
            loading: false,
            accomodationName: stayView.stay.accommodationName,
            stayStatus: stayView.stay.status,
            isOverlapDetected: isOverlapDetected,
            isMinimalHeight:
              (staffLayoutStyle$ | async) === StaffLayoutStyle.Minimal,
            itemHeight: itemHeight,
            isHighlighted: stayData.isStayHighlighted,
            isInvalid:
              !(data.validatedStays?.[stayView.stay.id] ?? true) &&
              !stayData.isStayHighlighted,
          };
        @defer (on hover) {
          <div
            (click)="
              data.canRenderStays &&
                selectStay(
                  {
                    stay: stayView.stay,
                    left: stayData.adjustedLeftPixel,
                    right: data.right,
                  },
                  undoTemplate
                )
            "
          >
            <ng-container
              *ngTemplateOutlet="stayTemplate; context: contextData"
            >
            </ng-container>
          </div>
        } @placeholder {
          <div>
            <ng-container
              *ngTemplateOutlet="stayTemplate; context: contextData"
            >
            </ng-container>
          </div>
        }
      </div>
    }
  }
</ng-container>

<ng-template #undoTemplate>
  <wilson-nz-message-timer-line [duration]="MESSAGE_DURATION">
    <wilson-message-with-undo-option
      (undo)="onUndo()"
    ></wilson-message-with-undo-option>
  </wilson-nz-message-timer-line>
</ng-template>
